import type { TranslateFunc } from 'src/components/translate';

export const getSizeTitle = (t: TranslateFunc) => {
  return `${t('product', 'label.size')}`;
};

export const getFractalRepresentation = (numericString: string) => {
  const integerValue = parseInt(numericString, 10);
  const decimalValue = parseFloat(numericString) % 1;
  if (isNaN(integerValue) || isNaN(decimalValue)) {
    return numericString;
  }
  if (decimalValue > 0.4 && decimalValue < 0.6) {
    return `${integerValue} ½`;
  }
  if (decimalValue > 0.25 && decimalValue < 0.4) {
    return `${integerValue} ⅓`;
  }
  if (decimalValue > 0.6 && decimalValue < 0.75) {
    return `${integerValue} ⅔`;
  }
  return numericString;
};
